export { hasBadWord } from "@chesshotel/types";
